
      if (import.meta.env.DEV) {
        console.log("DEV MODE:", import.meta.env.DEV);
        import("react-grab");
        import("@react-grab/claude-code/client");
      }
    